import { AutenticacionService } from './autenticacion.service';
import { Injectable } from '@angular/core';
import { CanActivate } from '@angular/router';

@Injectable({
  providedIn: 'root'
})
export class AuthGuardService implements CanActivate {

  constructor(
      public authenticationService: AutenticacionService
        ) {}

    canActivate(): boolean {
      return this.authenticationService.isAuthenticated();
    }

}
